/**
 * Created by Junhua on 2017/5/3.
 * 所有的过滤器写在这里
 */
export default {
    formatDate: function (date,fmt) {//日期格式化
        // var fmt = 'yyyy-MM-dd hh:mm:ss'
        var date = new Date(date);
        var o = {
            "M+": date.getMonth() + 1, //月份
            "d+": date.getDate(), //日
            "h+": date.getHours(), //小时
            "m+": date.getMinutes(), //分
            "s+": date.getSeconds(), //秒
            "q+": Math.floor((date.getMonth() + 3) / 3), //季度
            "S": date.getMilliseconds() //毫秒
        };
        if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
        for (var k in o)
            if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
        return fmt;
    },
    orderState: function (value) {
        if(value == '0'){
            return "生产中";
        }else if(value == '1'){
            return "完工";
        }else return '其他'
    },
    woState: function (value) {
        if(value == '0'){
            return "生产中";
        }else if(value == '1'){
            return "完工";
        }else if(value == '2'){
            return "已入库";
        }else if(value == '3'){
            return "已出货";
        }else return '其他'
    },
    payWay: function (value) {
        if(value == '0'){
            return "月结";
        }else if(value == '1'){
            return "现结";
        }else if(value == '2'){
            return "现汇";
        }else return '其他'
    },
    role: function (value) {
        if(value == '0'){
            return "管理员";
        }else if(value == '1'){
            return "产线管理员";
        }else if(value == '2'){
            return "线上用户";
        }else if(value == '3'){
            return "完工操作员";
        }else return '其他'
    },
    formula:function(value){
        value = value.replaceAll('l','长');
        value = value.replaceAll('w','宽');
        value = value.replaceAll('h','高');
        value = value.replaceAll('p','单价');
        value = value.replaceAll('/','÷');
        value = value.replaceAll('*','×');
        return value
    },
    changeMoneyToChinese(money){
        var cnNums = new Array("零","壹","贰","叁","肆","伍","陆","柒","捌","玖"); //汉字的数字
        var cnIntRadice = new Array("","拾","佰","仟"); //基本单位
        var cnIntUnits = new Array("","万","亿","兆"); //对应整数部分扩展单位
        var cnDecUnits = new Array("角","分","毫","厘"); //对应小数部分单位
        //var cnInteger = "整"; //整数金额时后面跟的字符
        var cnIntLast = "元"; //整型完以后的单位
        var maxNum = 999999999999999.9999; //最大处理的数字

        var IntegerNum; //金额整数部分
        var DecimalNum; //金额小数部分
        var ChineseStr=""; //输出的中文金额字符串
        var parts; //分离金额后用的数组，预定义
        if( money == "" ){
            return "";
        }
        money = parseFloat(money);
        if( money >= maxNum ){
            $.alert('超出最大处理数字');
            return "";
        }
        if( money == 0 ){
            //ChineseStr = cnNums[0]+cnIntLast+cnInteger;
            ChineseStr = cnNums[0]+cnIntLast
            //document.getElementById("show").value=ChineseStr;
            return ChineseStr;
        }
        money = money.toString(); //转换为字符串
        if( money.indexOf(".") == -1 ){
            IntegerNum = money;
            DecimalNum = '';
        }else{
            parts = money.split(".");
            IntegerNum = parts[0];
            DecimalNum = parts[1].substr(0,4);
        }
        if( parseInt(IntegerNum,10) > 0 ){//获取整型部分转换
            let zeroCount = 0;
            let IntLen = IntegerNum.length;
            for(let i=0;i<IntLen;i++ ){
                let n = IntegerNum.substr(i,1);
                let p = IntLen - i - 1;
                let q = p / 4;
                let m = p % 4;
                if( n == "0" ){
                    zeroCount++;
                }else{
                    if( zeroCount > 0 ){
                        ChineseStr += cnNums[0];
                    }
                    zeroCount = 0; //归零
                    ChineseStr += cnNums[parseInt(n)]+cnIntRadice[m];
                }
                if( m==0 && zeroCount<4 ){
                    ChineseStr += cnIntUnits[q];
                }
            }
            ChineseStr += cnIntLast;
            //整型部分处理完毕
        }
        if( DecimalNum!= '' ){//小数部分
            let decLen = DecimalNum.length;
            for(let i=0; i<decLen; i++ ){
                let n = DecimalNum.substr(i,1);
                if( n != '0' ){
                    ChineseStr += cnNums[Number(n)]+cnDecUnits[i];
                }
            }
        }
        if( ChineseStr == '' ){
            //ChineseStr += cnNums[0]+cnIntLast+cnInteger;
            ChineseStr += cnNums[0]+cnIntLast;
        }/* else if( DecimalNum == '' ){
                ChineseStr += cnInteger;
                ChineseStr += cnInteger;
            } */
        return ChineseStr;
    },
    delState(value) {
        if(value == '0'){
            return "未送货";
        }else if(value == '1'){
            return "已送货";
        }else return '其他'
    },
    cpState: function (value) {//计价单状态
        if(value == '0'){
            return "未生成订单";
        }else if(value == '1'){
            return "已生成订单";
        }else if(value == '2'){
            return "已完工";
        }else return '其他'
    },
    eOrderState: function (value) {//线上订单状态
        if(value == '0'){
            return "待确认";
        }else if(value == '1'){
            return "生产中";
        }else if(value == '2'){
            return "已完工";
        }else if(value == '3'){
            return "已发货";
        }else return '其他'
    },
    accRecType: function (value) {//账户变动类型
        if(value == '0'){
            return "应收";
        }else if(value == '1'){
            return "收款";
        }else if(value == '2'){
            return "退款";
        }else return '其他'
    },
    getPayType :function (value) {//账户变动类型
        if(value == '0'){
            return "现金";
        }else if(value == '1'){
            return "发票";
        }else return '其他'
    },
}
